import React, { useMemo } from "react";
import Styles from "./Navigation/NavigationDesktop.module.scss";
import Button from "@/shared/components/Button/Button";
import { useTranslation } from "react-i18next";
import Icon from "@/shared/components/Icon/Icon";
import useUser from "@/shared/hooks/useUser"; // Adjust the import path as needed
import Spinner from "@/shared/components/Spinner/Spinner";

const ProfileButton = ({ className, isMobile }: { className: string; isMobile?: boolean }) => {
  const { t } = useTranslation();
  const response = useUser();
  const { data: user, isFetching } = response;
  const userName = useMemo(() => {
    if (user?.firstname || user?.lastname) {
      return [user.firstname, user.lastname].join(" ");
    } else {
      return "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isFetching]);

  return isMobile ? (
    <>{userName || t("navbar.myProfile.navEntry")}</>
  ) : (
    <Button customColor className={className} style={{ minWidth: "100px" }}>
      <Icon name="accountCircle" size="22px" className={Styles.labelIcon} />
      {isFetching ? <Spinner size="small" /> : userName || t("navbar.myProfile.navEntry")}
    </Button>
  );
};

export default ProfileButton;
